export interface PlainValueProp {
  headline: string;
  problem: string;
  solution: string;
}

export const plainValueProps: Record<string, PlainValueProp> = {
  relayready: {
    headline: "Never rebuild the same school event from scratch.",
    problem: "PTA volunteers inherit scattered files, but not the decisions, responsibilities, deadlines, and vendor knowledge needed to run recurring events.",
    solution: "RelayReady converts last year's materials into a structured, reusable event plan the next volunteers can immediately operate.",
  },
  stitchfit: {
    headline: "Know an embroidery design will fit before the customer buys.",
    problem: "Embroidery buyers purchase designs that are incompatible with their machine or too large for their hoop.",
    solution: "StitchFit checks the buyer's machine and hoop against a design before purchase, preventing failed projects, refunds, and support requests.",
  },
  coursepatch: {
    headline: "Know exactly which lessons broke when software changes.",
    problem: "Software-course creators do not know which lessons become inaccurate when the software changes.",
    solution: "CoursePatch connects software features to course lessons and identifies which videos, screenshots, and instructions require review.",
  },
  directorypulse: {
    headline: "Keep a member directory accurate without chasing every member.",
    problem: "Association member directories decay as links break, company descriptions age, and members stop verifying their listings.",
    solution: "DirectoryPulse detects questionable listings and asks members to confirm or correct them, keeping the directory useful and current.",
  },
  ruleripple: {
    headline: "When Etsy changes a rule, know exactly which listings to review.",
    problem: "Etsy sellers must manually inspect their entire catalog after a marketplace policy changes.",
    solution: "RuleRipple maps each policy change against the seller's catalog and produces a focused list of products that require review.",
  },
};

export function valuePropFor(venture: { slug: string; pain: string; product: string }): PlainValueProp {
  return plainValueProps[venture.slug] ?? {
    headline: venture.product,
    problem: venture.pain,
    solution: venture.product,
  };
}
